import { createContext, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "../common/Icon";
import Logo from "../common/Logo";
import { getCurrentProfile, getCurrentUser, signOut } from "../../services/authService";
import "../../modules/admin/admin.css";

const AdminLayoutContext = createContext(null);

export function useAdminLayout() {
  return useContext(AdminLayoutContext);
}

export default function AdminLayout({ children }) {
  const [profile, setProfile] = useState(null);
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("trishul_admin_sidebar_collapsed") === "true";
    } catch {
      return false;
    }
  });
  const [pageTitle, setPageTitle] = useState("Admin Dashboard");

  useEffect(() => {
    try {
      localStorage.setItem("trishul_admin_sidebar_collapsed", String(collapsed));
    } catch {}
  }, [collapsed]);

  useEffect(() => {
    getCurrentUser().then(({ user }) => user && getCurrentProfile(user.id).then(({ data }) => setProfile(data)));
  }, []);

  async function logout() {
    await signOut();
    window.location.assign("/admin/login");
  }

  return (
    <AdminLayoutContext.Provider value={{ collapsed, setCollapsed, pageTitle, setPageTitle }}>
      <div className="admin-top-nav">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button
            className="admin-collapse"
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            type="button"
            onClick={() => setCollapsed((value) => !value)}
          >
            <Icon name="ic-menu" />
          </button>
          <Logo variant="admin" to="/admin/dashboard" aria-label="Trishul Tours & Travels admin dashboard" />
        </div>
        <div className="admin-page-heading">{pageTitle}</div>
        <div className="admin-header-actions">
          <span className="admin-username">{profile?.full_name || profile?.username || "Admin"}</span>
          <button className="admin-logout" type="button" onClick={logout}>
            <Icon name="ic-logout" /> Logout
          </button>
          <Link className="admin-website-link" to="/">Website</Link>
        </div>
      </div>
      {children}
      <div className="admin-footer-bottom">
        <span>© {new Date().getFullYear()} Trishul Tours &amp; Travels</span>
        <a
          href="https://inspirationsoftsolutions.com/"
          target="_blank"
          rel="noreferrer"
        >
          Designed &amp; developed by Inspiration Soft Solutions
        </a>
      </div>
    </AdminLayoutContext.Provider>
  );
}
